import React, { useRef, useState, useEffect } from "react"
import Slider from "react-slick"
import { graphql, Link, useStaticQuery, withPrefix } from "gatsby"
import BackgroundImage from "gatsby-background-image"
import ChangeMakersNewsletter from "./components/Newsletter"
import { useLocale } from "context/locale"
// import NextArrowIcon from "icons/arrow_right.svg"

import StyledChangeMakers from "./styles"

const ChangeMakers = () => {
  const { t } = useLocale()
  const [active_slide, setSlide] = useState(0)
  const data = useStaticQuery(
    graphql`
      query {
        tomasz: file(
          relativePath: { eq: "change_makers/changemakger-tomasz.jpg" }
        ) {
          childImageSharp {
            fluid(quality: 100) {
              ...GatsbyImageSharpFluid_noBase64
            }
          }
        }
        anna: file(
          relativePath: { eq: "change_makers/changemakger-ania-zajac.jpg" }
        ) {
          childImageSharp {
            fluid(quality: 100) {
              ...GatsbyImageSharpFluid_noBase64
            }
          }
        }
        magdalena: file(
          relativePath: { eq: "change_makers/changemakger-magdalena.jpg" }
        ) {
          childImageSharp {
            fluid(quality: 100) {
              ...GatsbyImageSharpFluid_noBase64
            }
          }
        }
      }
    `
  )
  const change_makers = [
    {
      id: 0,
      name: "Tomasz",
      image: data.tomasz.childImageSharp.fluid,
      description: t(
        "At Ubrania do Oddania we put words into ACTION! What 4 years ago seemed to be a dream, now is a reality as circular fashion becomes a thing! It’s not a vision of change anymore, it’s a real change of fashion market that takes place in front of our eyes. There’s still plenty to do and we continuously learn how to effectively promote closed loop approach among fashion brands. Thanks to the projects led with our partners such as OTCF, we know for sure that it’s possible on a huge scale!"
      ),
    },
    // {
    //   id: 1,
    //   name: "Jakub",
    //   image: data.jakub.childImageSharp.fluid,
    //   description: t(
    //     "For me, the decision to join and work on the 4F Change programme is a manifestation of my strength. For the sake of the planet, I take up a daily battle against the world around me, but also against myself. Small choices and big decisions-everything matters. That's why I try to make them fully aware of how they can affect the environment and be a role model for others."
    //   ),
    // },
    // {
    //   id: 2,
    //   name: "Aleksandra",
    //   image: data.aleksandra.childImageSharp.fluid,
    //   description: t(
    //     "It’s time to change the way we act – our habits and our lifestyle – and start respecting our planet. That’s what we often hear but not so often actually do. I began by saving energy, segregating waste, selling things I no longer needed, buying second-hand products, choosing public transport, bike or walk instead of going everywhere by car and introducing upcycling into my work. These are small changes but I’m proud of them. And what do YOU do for the planet?"
    //   ),
    // },
  ]
  const background_slider = useRef(null)
  const text_slider = useRef(null)
  const background_settings = {
    dots: false,
    infinite: false,
    swipe: true,
    arrows: false,
    autoplay: false,
    speed: 600,
    ref: background_slider,

    onSwipe: direction => {
      direction === "left"
        ? setSlide(active_slide >= 2 ? 2 : active_slide + 1)
        : setSlide(active_slide === 0 ? 0 : active_slide - 1)
    },
  }
  const text_settings = {
    dots: false,
    infinite: false,
    swipe: false,
    fade: true,
    arrows: false,
    autoplay: false,
    speed: 600,
    ref: text_slider,
  }

  useEffect(() => {
    background_slider.current.slickGoTo(active_slide)
    text_slider.current.slickGoTo(active_slide)
  }, [active_slide])

  return (
    <StyledChangeMakers className="change-makers">
      <div className="change-makers__wrapper">
        <div className="change-makers__gallery">
          {/* <button
            className="btn-next"
            type="button"
            aria-label="next"
            onClick={() => {
              setSlide(active_slide === 2 ? 0 : active_slide + 1)
            }}
          >
            <NextArrowIcon />
          </button> */}
          <Slider {...background_settings}>
            {change_makers.map(({ image }, index) => (
              <BackgroundImage
                key={index}
                fluid={image}
                className="slide-inner"
                backgroundColor="#fff"
              />
            ))}
          </Slider>
          {/* <div className="gallery-navigation">
            {change_makers
              .filter(({ id }) => id !== active_slide)
              .map(({ id, name, image }) => (
                <button
                  className="gallery-navigation__item"
                  key={id}
                  onClick={() => setSlide(id)}
                >
                  <BackgroundImage
                    className="item-background"
                    fluid={image}
                    backgroundColor="#fff"
                  >
                    <div className="item-background__inner">
                      <p className="bolder item-text">{name}</p>
                    </div>
                  </BackgroundImage>
                </button>
              ))}
          </div> */}
        </div>
        <div className="change-makers__info">
          <div className="info-header">
            <h2 className="title h1">{t("Become a changemaker")}</h2>
          </div>
          <div className="info-slider">
            <Slider {...text_settings}>
              {change_makers.map(({ id, name, description }) => (
                <div className="change-maker" key={id}>
                  <p className="bolder change-maker__name">{name}</p>
                  <p className="change-maker__desc">{description}</p>
                  <Link
                    className="change-maker__link bolder"
                    to={t("about_us_link")}
                  >
                    {t("Get to know our Changemakers")}
                  </Link>
                  <a
                    className="change-maker__link change-maker__link--pdf bolder"
                    href={withPrefix(t("/4Fchange_poradnik_2024_ENG.pdf"))}
                    target="_blank"
                    rel="noreferrer"
                  >
                    {t("Download the manual “How to become a Changemaker”")}
                  </a>
                </div>
              ))}
            </Slider>
          </div>
          <ChangeMakersNewsletter />
        </div>
      </div>
    </StyledChangeMakers>
  )
}

export default ChangeMakers
